import {
  CHECK_USER_EXIST_SUCCESS,
  FORBIDDEN_ACTION,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  NEW_USER_CREATED,
  UNAUTHORIZED_USER,
} from "../types/authTypes";
import { SET_NEXT_URL, SET_ROUTE_REDUCER } from "../types/routeTypes";

const initState = { nextUrl: "/", navigated: false, initialFetch: false };

const routeReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_NEXT_URL:
      return {
        ...state,
        nextUrl: action.url,
      };
    case SET_ROUTE_REDUCER:
      return {
        ...state,
        ...action.payload,
      };
    case GOOGLE_LOGIN_SUCCESS:
    case LOGIN_SUCCESS:
      return {
        ...state,
        nextUrl: "/dashboard",
      };
    case CHECK_USER_EXIST_SUCCESS:
      return {
        ...state,
        nextUrl: "/password",
      };
    case NEW_USER_CREATED: {
      return {
        ...state,
        nextUrl: "/login/otp",
      };
    }
    case LOGOUT_SUCCESS:
    case UNAUTHORIZED_USER:
    case FORBIDDEN_ACTION:
      return initState;
    default:
      return state;
  }
};

export default routeReducer;
